import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  style: z.enum(["solid", "dashed"]).default("solid"),
});

export const dividerField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "divider",
  label: "Divider",
  category: "layout",
  icon: "Minus",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { style: "solid" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
